import { useMutation } from "@tanstack/react-query";
import AIToolsAPI from "../../api/AIToolsAPI";

interface SentimentAnalysisProps {
  text: string;
}

const useSentimentAnalysis = () => {
  const sentimentAnalysis = useMutation({
    mutationFn: ({ text }: SentimentAnalysisProps) =>
      AIToolsAPI.sentimentAnalysis(text).then((data) => {
        if (!data?.data?.data?.analysis || data?.data?.data?.error === true) {
          return Promise.reject("No results found.");
        }

        return data.data.data.analysis;
      }),
  });

  return {
    sentimentAnalysis: sentimentAnalysis.mutate,
    sentimentAnalysisLoading: sentimentAnalysis.isPending,
    sentimentAnalysisError: sentimentAnalysis.error,
    sentimentAnalysisResult: sentimentAnalysis.data,
  };
};

export default useSentimentAnalysis;
